export enum StoredCookies {
	ACCESS_TOKEN = 'accessToken',
	USERNAME = 'username',
	REFRESH_TOKEN = 'refreshToken',
}
